import type { FlagCategory } from "../../../../components/mediasoup-ui/flagConstants.";


export interface StatCardProps {
  cardKey: string;
  label: string;
  scrollTo: string;
  dotColor: string;
  valueColor: string;
  pulse: boolean;
  value: number;
  subLabel: string;
  isStale: boolean;
  isFlashing: boolean;
}

export interface KpiData {
  liveStreams:      number;
  totalCourtrooms:  number;
  archivalPending:  number;
  archivalTotal:    number;
  flaggedCount:     number;
  flagPIICount:     number;
  flagConductCount: number;
  flagOtherCount:   number;
  recordingToday:   number;
  storageTodayGB:   string;
}
export interface FlagSubLabel {
  pii: number;
  conduct: number;
}

// ─── ROOMS ───────────────────────────────────────────────────────────────────
export type RoomStatus =
  | "live"
  | "paused"
  | "flagged"
  | "rec"
  | "offline";

export interface FlagRef {
  resolved: boolean;
}

export interface Room {
  id: string;
  blk: string;
  status: RoomStatus;
  cs: string;
  jg: string;
  vw: number;
  dur: string;
  bg: string;
  gl: string;
  cam: string;
  hlsUrl?: string;
  ts?: string;
  bench?: string;
  flagType?: string;
  offReason?: string;
  nextSession?: string;
  flags?: FlagRef[];
   cnr?: string;          
  courtRoomNo?: string;  
  courtRoomId?: string; 
  initialSnapUrl?: string;
}

// ─── FLAGS ───────────────────────────────────────────────────────────────────
export type FlagStatus = "unresolved" | "masked" | "muted" | "dismissed";
 
export interface Flag {
  id: string;
  tp: "pii" | "conduct";
  rv: boolean;
  flagStatus: FlagStatus;
  tm: string;
  rm: string;
  tg: string;
  ds: string;
  dr: string;
  startTime?: number;
  endTime?: number;
}


// ─── TOAST ───────────────────────────────────────────────────────────────────
export interface Toast {
  id: number;
  msg: string;
  col: string;
}

// ─── COMPONENT PROPS ─────────────────────────────────────────────────────────
export interface CourtCardProps {
  room: Room;
  idx: number;
  isPlaying: boolean;
  onPlay: (idx: number) => void;
  snapUrl?: string | null;
  onStop: () => void;
  onCardClick: (idx: number) => void;
  roomFlags:Flag[];
}

export interface CourtSceneProps {
  room: Room;
  idx: number;
  snapUrl?: string | null;

}

export interface StatusPillProps {
  st: RoomStatus;
}

export interface SummaryBarProps {
  rooms: Room[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

export interface FlagsPanelProps {
  flags: Flag[];
  setFlags: React.Dispatch<React.SetStateAction<Flag[]>>;
  onFlagCountChange?: (pii: number, conduct: number) => void;
  onToast: (msg: string, col?: string) => void;
  onLoadMore?: () => void;
  hasMore?: boolean;
  loadingMore?: boolean;
}

export interface ToastsProps {
  toasts: Toast[];
}

export interface ControlStripProps {
  room: Room;
  onStop: () => void;
  muted: boolean;
  onToggleMute: () => void;
  onToast: (msg: string, col?: string) => void;
}

export interface ActionBtnProps {
  cls: string;
  icon: React.ReactNode;
  label: string;
  action: () => void;
}

export const FLAG_TYPE_MAP: Record<FlagCategory, string> = {
  PII: "PII",
  Conduct: "Conduct",
  Witness: "Witness",
  Restricted: "Restricted",
  Technical: "Technical",
};

// ─── TIMELINE ────────────────────────────────────────────────────────────────
export type SegType = "l" | "f" | "r" | "rc";

export type Segment = {
  t: SegType | "N";
  f?: number;
  lb?: string;
  ti?: string;
  flagId?: string; 
   flagReason?: string; 
};

// ─── KPI STRIP PROPS ─────────────────────────────────────────────────────────
export interface KpiStatStripProps {
  activePii: number;
  activeConductCount: number;
  activeFlagCount: number;
}

// ─── TILT HOOK ───────────────────────────────────────────────────────────────
export interface UseTiltReturn<T extends HTMLElement = HTMLElement> {
  glowRef: React.RefObject<HTMLDivElement | null>;
  onMouseMove: (e: React.MouseEvent<T>, card: T) => void;
  onMouseLeave: (card: T) => void;
}